<template>
  <!--nav-->
  <nav class="navbar navbar-default no-margin app-sidebar-nav">
    <!-- Brand and toggle get grouped for better mobile display -->
    <div class="navbar-header fixed-brand">
      <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" id="menu-toggle">
        <span class="glyphicon glyphicon-th-large" aria-hidden="true"></span>
      </button>
      <a class="navbar-brand" href="#">
        <img src="/static/images/logo.png" alt="Velocity Vehicle Group" />
      </a>
    </div>
    <!-- navbar-header-->
    <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
      <ul class="nav navbar-nav">
        <li class="active">
          <button class="navbar-toggle collapse in" data-toggle="collapse" id="menu-toggle-2">
            <img src="/static/images/menubar.png" alt="Menu" class="menubar" />
          </button>
        </li>
      </ul>
    </div>
    <!--notification-->
    <!-- <div class="notification">
        <a href="#">
        <img src="/static/images/notification-bell.png" alt="Notification">
        </a>
    </div>-->
    <div class="user-location" v-if="location != ''">
      <img src="/static/images/location-logo-red.png" alt="Location" />
      <div class="user-location-name">{{location}}</div>
    </div>
    <!--notification-->
    <!--userinfo-->
    <div class="user-info">
      <div class="user-info-container">
        <div class="dropdown">
          <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
            <div class="dropdown-user">
              <div class="username-letter">{{iconLetters}}</div>
              <div class="dropdown-user-right">
                <div class="username">{{firstName}} {{lastName}}</div>
                <br />
                <div class="usermailid">{{username}}</div>
              </div>
            </div>
          </button>
          <div class="dropdown-menu">
            <!-- <a class="dropdown-item" href="#">My Profile</a> -->
            <template v-if="isWillCallLocation">
              <a
                class="dropdown-item"
                href="javascript:void(0)"
                v-on:click.prevent="toggleLocation(switchTextView)"
              >Switch to {{ switchTextView }}</a>
            </template>
            <a class="dropdown-item" href="javascript:void(0)" v-on:click.prevent="logout()">Logout</a>
          </div>
        </div>
      </div>
    </div>
    <!--userinfo-->
    <!-- bs-example-navbar-collapse-1 -->
  </nav>
  <!--nav-->
</template>

<script>
import Vue from "vue";
import EventBus from "./event-bus";
import { HTTP } from "../http-common";
import Swal from "sweetalert2";

var self;
export default {
  name: "FrontHeader",
  components: {},
  data() {
    return {
      username: "",
      firstName: "",
      lastName: "",
      locationID: 0,
      location: "",
      iconLetters: "",
      switchTextView: "Primary Location",
      isWillCallLocation: false,
      isFromError: false
    };
  },

  beforeMount: function() {
    self = this;
  },
  mounted: function() {
    self = this;
    var userObj = JSON.parse(localStorage.getItem("user_obj"));
    if (userObj != null) {
      var userId = userObj.id;
      self.locationID = userObj.location_id;
      EventBus.$emit(
        "login-user-info",
        userObj.username,
        userObj.first_name,
        userObj.last_name,
        userObj.location_name,
        userObj.will_call_location_name
      );
    }
  },
  methods: {
    logout: function () {
        //clear all local storage
        localStorage.clear();
        EventBus.$emit("logout-user-stop-event-source");
        // Auto-logout Current Project From SSO
        window.location.href = process.env.VUE_APP_SSO_ROOT_URL + "/logout?redirect_url=" + process.env.FRONT_ROOT_API + '&slug=' + process.env.PROJECT_SLUG;
    },

    userLocation: function() {
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("api_token")
        }
      };

      var data = {
        location_id: self.locationID
      };
      HTTP.post("userlocation", data, config)
        .then(function(response) {
          if (response.data.code == "200") {
            self.location = response.data.content.location;
          }
        })
        .catch(function(err) {
          if (err.response.status == 0) {
            self.error = "Remote server can not be reachable";
          } else {
          }
        });
    },
    toggleLocation: function(switchText) {
      let self = this;

      self.changeUserCurrentLocation(switchText);
    },

    changeUserCurrentLocation: function(switchText) {
      let self = this;
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("api_token")
        }
      };

      let location = "";

      if (switchText == "Primary Location") {
        location = "primary";
      } else {
        location = "secondary";
      }

      let data = {
        user_current_location: location
      };

      Swal({
        title: "Are you sure?",
        text: "You want to change location to " + switchText + "!",
        type: "info",
        showConfirmButton: true,
        confirmButtonText: "OK",
        showCloseButton: true,
        cancelButtonText: "Cancel"
      }).then(response => {
        if (response.value) {
          HTTP.post("/user/change-user-current-location", data, config)
            .then(function(response) {
              if (response.data.code == 200) {
                let current_location_view = localStorage.getItem(
                  "current_location_view"
                );
                // Check if Current View is Front End or Will Call.
                if (current_location_view == "front_end") {
                  self.switchTextView = "Primary Location";
                  window.localStorage.setItem(
                    "current_location_view",
                    "will_call"
                  );
                  self.location = JSON.parse(
                    localStorage.getItem("user_obj")
                  ).will_call_location_name;
                } else {
                  self.switchTextView = "Secondary Location";
                  window.localStorage.setItem(
                    "current_location_view",
                    "front_end"
                  );
                  self.location = JSON.parse(
                    localStorage.getItem("user_obj")
                  ).location_name;
                }

                // self.successAlert();
                EventBus.$emit(
                  "toggle-location",
                  localStorage.getItem("current_location_view")
                );
              }
            })
            .catch(function(err) {
              console.log(err);
              self.isFromError = true;
              self.displayAlertOnError(err, switchText);

              if (err.response.status == 0) {
                self.error = "Remote server can not be reachable";
              } else {
                //redirect to login page if user not authenticated
                if (err.response.status == 401) {
                  //clear previous data
                  localStorage.removeItem("user_obj");
                  localStorage.removeItem("api_token");
                  localStorage.removeItem("profile_image");
                  //EventBus.$emit("logged-in", true, "", "");
                  self.$router.push("/login");
                }
                self.error = err.response.data.message;
              }
              // self.displayAlertOnError(self.error);
            });
        }
      });
    },

    displayAlertOnError: function(error, switchText) {
      let self = this;
      Swal.fire({
        title: "There is some error",
        text: error,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Retry"
      }).then(result => {
        if (result.value) {
          ("Please wait...");
          self.changeUserCurrentLocation(switchText);
        }
      });
    },

    successAlert() {
      let self = this;
      if (self.isFromError) {
        // Swal.fire('Success');
        Swal.fire({
          icon: "success",
          title: "Success",
          showConfirmButton: true,
          timer: 2000
        });
      }
      self.isFromError = false;
    }
  }
};

EventBus.$on("login-user-info", function(
  user_name,
  first_name,
  last_name,
  location_name,
  will_call_location_name
) {
  if (typeof self != "undefined") {
    self.username = user_name;
    if (first_name != null || last_name != null) {
      self.firstName = first_name;
      self.lastName = last_name;
    } else {
      self.firstName = "NA";
      self.lastName = "";
    }
    //First Two Characters in Upper Case of Username in iconLetters
    self.iconLetters = self.username.substring(0, 2).toUpperCase();
    self.location = location_name;

    if (will_call_location_name != null) {
      self.isWillCallLocation = true;
      let current_view = localStorage.getItem("current_location_view");
      // Check if Current View is Front End or Will Call.
      if (current_view == "front_end") {
        self.switchTextView = "Secondary Location";
        self.location = JSON.parse(
          localStorage.getItem("user_obj")
        ).location_name;
      } else {
        self.switchTextView = "Primary Location";
        self.location = JSON.parse(
          localStorage.getItem("user_obj")
        ).will_call_location_name;
      }
    } else {
      self.isWillCallLocation = false;
    }
  }
});
</script>


// WEBPACK FOOTER //
// src/components/FrontHeader.vue